export default {
    leftParenthesis: '{',
    rightParenthesis: '}',
    button: {
        run: 'Spusti',
        save: 'Uložiť',
        cancel: 'Zrušiť'
    },
    menu:{
        dashboard: 'Dashboard',
        projects: 'Projekty',
        formatter: 'Vytvor JSON',
        pageModeler: 'Generátor stránok',
        addcomponents: 'Pridať komponent',
        about: 'O mne',
        learn: 'Ako to funguje',
        inprogress: 'Pripravujem',
        donate: 'Dotácia'
    }
}
